/**
 * @file
 * Block: Main Menu.
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.medihumBlockMainMenu = {
    attach: function (context, settings) {
      var $context = $(context);
      var translations = Drupal.behaviors.medihumTranslation.getTranslations();

      $('.block-main-menu').once('main-menu-process').each(function () {
        var $nav = $(this);
        var $body = $('body');
        var $header = $body.find('header.header');
        var $wrapper = $header.find('.mobile-menu-wrapper-inner');

        var main_menu = $nav.find('ul.menu').html();
        var category_menu = drupalSettings.medihum_base.product_categories_list;
        var menu = $('<ul><li>' + translations.mainMenu+ '</li><li><a href="#">' + translations.productCatalogue + '</a>' + category_menu + '</li>' + main_menu + '</ul>');

        $wrapper.append(menu);
        const slinky = $wrapper.slinky({title: true});

        $header.on('click', 'i.open-menu-btn', function (e) {
          if ($body.hasClass('navigation-expand')) {
            $(this).removeClass('icon-close').addClass('icon-menu-open');
            slinky.home();
          }
          else {
            $(this).removeClass('icon-menu-open').addClass('icon-close');
            if ($body.hasClass('mobile-search-open')) {
              $body.removeClass('mobile-search-open');
            }
          }

          $body.toggleClass('navigation-expand');
        });

        $header.on('click', '.catalog-wrapper > a', function (e) {
          e.preventDefault();

          if ($(window).width() > 768) {
            $body.toggleClass('category-menu-open');
          }
          else {
            $wrapper.find('> ul > li:nth-child(2) > a.next').click();
            $header.find('i.open-menu-btn').click();
          }
        });

        $('.page-overlay').bind('click', function () {
          if ($body.hasClass('category-menu-open')) {
            $body.removeClass('category-menu-open');
          }
        })
      });
    }
  };

})(jQuery, Drupal);
